import React from "react";
import {type AxiosError} from "axios";
import ErrorFallback from "../error/ErrorFallback.tsx";
import BrandMarkSVG from "../icons/BrandMarkSVG.tsx";

interface FrameLoadProps {
    error?: Error | AxiosError;
    label?: string;
}

const FrameLoad: React.FC<FrameLoadProps> = ({error, label}) => {
    const status =
        (error && "isAxiosError" in error && (error).response?.status) ?? undefined;
    const is4xx = status && status >= 400 && status < 500;

    if (error) {
        return <ErrorFallback error={error} is4xx={!!is4xx}/>;
    }

    return (
        <div className="flex flex-col items-center justify-center h-full min-h-[60vh] gap-6">
            <div className="an-shape an-shape-shadow bg-an-surface px-10 py-6">
                <BrandMarkSVG className="block h-20 w-auto"/>
            </div>
            {label && (
                <div className="font-lato font-bold text-an-ink text-lg">{label}</div>
            )}
            <div className="flex gap-2">
                <span className="block w-2 h-2 rounded-full bg-an-green-300 animate-bounce" style={{animationDelay: "0ms"}}/>
                <span className="block w-2 h-2 rounded-full bg-an-green-300 animate-bounce" style={{animationDelay: "150ms"}}/>
                <span className="block w-2 h-2 rounded-full bg-an-green-300 animate-bounce" style={{animationDelay: "300ms"}}/>
            </div>
        </div>
    );
};

export default FrameLoad;
